module.exports = function() {
  return new Worker(__webpack_public_path__ + "fd4dd8426ad59ded5971.worker.js");
};